import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import { thunk } from "redux-thunk";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import authReducer from "./authSlice";
import toggleSidebar from "./toggleSidebar";
import balanceReducer from "./balance/balanceSlice.js";

const rootReducer = combineReducers({
  auth: authReducer,
  sidebar: toggleSidebar,
  balance: balanceReducer,
});

const persistConfig = {
  key: "root",
  storage: storageSession,
  blacklist: ["advanceFilter"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: "production",
  // middleware: [thunk]
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export const persistor = persistStore(store);

export const clearLocalStorageOnLogout = () => {
  persistor.purge(); // This will clear the entire persisted state
  // You can also clear specific items from local storage if needed
  // localStorage.removeItem('persist:root');
};
